import classNames from 'classnames';
import BasicPicker from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import { useMemo } from 'react';
import { ReactNode } from 'react';
import { IPositionPickerProps } from '../PositionPicker/PositionPicker';
import { usePositionPickerData } from '../hooks/usePositionPickerData';

export default function AutoHidePositionPicker({
  permissions,
  className,
  header,
  ...pickerProps
}: IPositionPickerProps & { header?: ReactNode }) {
  const { positions } = usePositionPickerData(permissions);

  const data = useMemo(() => positions.map((p) => ({ id: p.id, name: p.title })), [positions]);

  if (data.length <= 1) {
    return null;
  }

  return (
    <>
      {header ?? null}
      <BasicPicker {...pickerProps} className={classNames('position-picker', className)} data={data} />
    </>
  );
}
